/*
 * Testi della pagina "accesso non abilitato": STESSO FILE in ServiceGo.Frontend, ServiceGo.AdminFrontend e
 * Linde ServiceInsight (CleverFlow li ha nei locales in src, Vivisol nella view). Stanno qui e non in
 * public/shared/base/translate perche' /shared allo startup viene sovrascritto.
 */
const texts = {
  it: {
    title: "Accesso non abilitato",
    checking: "Verifica dei permessi in corso…",
    loggedAs: "Sei autenticato come",
    unknownUser: "utente sconosciuto",
    reason_app: "Questo account non è abilitato all'utilizzo di questa applicazione.",
    reason_permissions: "Questo account non ha ancora ruoli o permessi assegnati per questa applicazione.",
    reason_customers: "Questo account non è associato ad alcun cliente.",
    reason_country: "La nazione associata a questo account non è configurata.",
    stillUnauthorized: "I permessi non risultano ancora assegnati.",
    help: "Se i permessi ti sono stati appena assegnati premi \"Riprova\", altrimenti contatta l'amministratore oppure accedi con un altro utente.",
    retry: "Riprova",
    changeUser: "Cambia utente"
  },
  en: {
    title: "Access not enabled",
    checking: "Checking permissions…",
    loggedAs: "You are signed in as",
    unknownUser: "unknown user",
    reason_app: "This account is not enabled to use this application.",
    reason_permissions: "This account has no roles or permissions assigned for this application yet.",
    reason_customers: "This account is not associated with any customer.",
    reason_country: "The country associated with this account is not configured.",
    stillUnauthorized: "Permissions are not assigned yet.",
    help: "If your permissions have just been assigned, press \"Retry\"; otherwise contact your administrator or sign in with a different user.",
    retry: "Retry",
    changeUser: "Change user"
  },
  es: {
    title: "Acceso no habilitado",
    checking: "Verificando permisos…",
    loggedAs: "Has iniciado sesión como",
    unknownUser: "usuario desconocido",
    reason_app: "Esta cuenta no está habilitada para usar esta aplicación.",
    reason_permissions: "Esta cuenta aún no tiene roles ni permisos asignados para esta aplicación.",
    reason_customers: "Esta cuenta no está asociada a ningún cliente.",
    reason_country: "El país asociado a esta cuenta no está configurado.",
    stillUnauthorized: "Los permisos aún no están asignados.",
    help: "Si te acaban de asignar los permisos, pulsa \"Reintentar\"; de lo contrario, contacta con el administrador o inicia sesión con otro usuario.",
    retry: "Reintentar",
    changeUser: "Cambiar usuario"
  },
  ca: {
    title: "Accés no habilitat",
    checking: "S'estan verificant els permisos…",
    loggedAs: "Has iniciat sessió com a",
    unknownUser: "usuari desconegut",
    reason_app: "Aquest compte no està habilitat per utilitzar aquesta aplicació.",
    reason_permissions: "Aquest compte encara no té rols ni permisos assignats per a aquesta aplicació.",
    reason_customers: "Aquest compte no està associat a cap client.",
    reason_country: "El país associat a aquest compte no està configurat.",
    stillUnauthorized: "Els permisos encara no estan assignats.",
    help: "Si t'acaben d'assignar els permisos, prem \"Torna-ho a provar\"; en cas contrari, contacta amb l'administrador o inicia sessió amb un altre usuari.",
    retry: "Torna-ho a provar",
    changeUser: "Canvia d'usuari"
  },
  pl: {
    title: "Dostęp nieaktywny",
    checking: "Sprawdzanie uprawnień…",
    loggedAs: "Jesteś zalogowany jako",
    unknownUser: "nieznany użytkownik",
    reason_app: "To konto nie ma uprawnień do korzystania z tej aplikacji.",
    reason_permissions: "To konto nie ma jeszcze przypisanych ról ani uprawnień w tej aplikacji.",
    reason_customers: "To konto nie jest powiązane z żadnym klientem.",
    reason_country: "Kraj przypisany do tego konta nie jest skonfigurowany.",
    stillUnauthorized: "Uprawnienia nie zostały jeszcze przypisane.",
    help: "Jeśli uprawnienia zostały właśnie przypisane, kliknij \"Spróbuj ponownie\"; w przeciwnym razie skontaktuj się z administratorem lub zaloguj się jako inny użytkownik.",
    retry: "Spróbuj ponownie",
    changeUser: "Zmień użytkownika"
  },
  ro: {
    title: "Acces neactivat",
    checking: "Se verifică permisiunile…",
    loggedAs: "Ești autentificat ca",
    unknownUser: "utilizator necunoscut",
    reason_app: "Acest cont nu are acces la această aplicație.",
    reason_permissions: "Acest cont nu are încă roluri sau permisiuni atribuite pentru această aplicație.",
    reason_customers: "Acest cont nu este asociat cu niciun client.",
    reason_country: "Țara asociată acestui cont nu este configurată.",
    stillUnauthorized: "Permisiunile nu sunt încă atribuite.",
    help: "Dacă permisiunile tocmai ți-au fost atribuite, apasă \"Reîncearcă\"; altfel contactează administratorul sau autentifică-te cu alt utilizator.",
    retry: "Reîncearcă",
    changeUser: "Schimbă utilizatorul"
  }
};

export const getUnauthorizedTexts = (lang) => {
  const normalized = (lang || "").toLowerCase();
  return texts[normalized] || texts[normalized.split("-")[0]] || texts.en;
};
